import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

const Fileupload = ({
  file,
  setFiles,
  setSelectedData,
  category,
  setFileName,
  emptyFile,
}) => {
  const [dragging, setDragging] = useState(false);
  const [inputFiles, setInputFiles] = useState({
    name: "",
    size: "",
    content: "",
  });
  const fileInputRef = useRef(null);
  const [encrypted, setencrypted] = useState("");

  const { pages } = useParams();

  const currentpage = pages.toLowerCase();

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true); // Highlight the area when dragging files
  };

  useEffect(() => {
    if (setSelectedData) {
      setSelectedData((prev) => ({
        ...prev,
        filename: inputFiles.name,
        fileObject: inputFiles.fileObject,
      }));
    } else {
      if (setFiles) {
        setFiles(inputFiles.fileObject);
      }
      if (setFileName) {
        setFileName(inputFiles.name);
      }
    }
  }, [inputFiles, setSelectedData]);

  const handleClick = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  console.log(inputFiles);

  const handleDragLeave = () => {
    setDragging(false); // Remove highlight when leaving
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false); // Remove highlight when dropping files
    const files = e.dataTransfer.files;
    handleFiles(files); // Handle dropped files
  };

  const handleFiles = (files) => {
    // Reset inputFiles if needed
    setInputFiles("");

    if (files && files[0]) {
      const file = files[0]; // Get the first file
      const { name, size } = file;

      // Update the state with file object and metadata (no base64 conversion)
      setInputFiles({
        fileObject: file, // Store the File object directly
        name: name,
        size: size,
        // No 'content' field needed
      });
    }
  };
  useEffect(() => {
    if (emptyFile === 1) {
      setInputFiles({
        name: "",
        size: "",
        content: "",
      });
    }
  }, [emptyFile]);

  return (
    <div className="w-full">
      <div
        className="flex w-full bg-white border-[1px] border-commonborder p-6 rounded-[24px]"
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        {dragging ? (
          <div className="flex bg-commonfill min-h-[200px] w-full justify-center items-center flex-col">
            <div className="w-auto h-auto mb-6">
              <img
                src={process.env.PUBLIC_URL + "/images/dropfilelogo.png"}
                alt="icon"
              />
            </div>
            <p className="text-8C8A9B">Drop your files here</p>
          </div>
        ) : (
          <div className="bg-commonfill border-[1px] border-highlight border-dashed py-12 flex flex-col justify-center w-full items-center rounded-[16px]">
            <div className="w-auto h-auto mb-6">
              <img
                src={process.env.PUBLIC_URL + "/images/dropfilelogo.png"}
                alt="icon"
              />
            </div>
            <h1 className="text-18">
              Drag and Drop files here or{" "}
              <button
                onClick={(e) => handleClick(e)}
                className="text-18 text-154A79 font-semibold underline underline-offset-2 text-highlighttext"
              >
                Choose file
              </button>
            </h1>
            <input
              type="file"
              name="project_name"
              placeholder="Enter Project Name"
              ref={fileInputRef}
              style={{ display: "none" }} // hide the file input
              multiple
              onChange={(e) => {
                handleFiles(e.target.files);
              }}
              onClick={(e) => (e.target.value = null)}
              accept={
                category === "4"
                  ? ".csv"
                  : category === "5"
                  ? ".xlsx, .xls"
                  : category === "6"
                  ? ".pdf"
                  : category === "7"
                  ? ".zip,application/zip,application/x-zip-compressed"
                  : currentpage === "latex_to_html"
                  ? ".tex"
                  : ".epub"
              }
            />
            <div className="mt-3">
              <p className="text-8C8A9B">{`Supported formats: ${
                category === "4"
                  ? ".csv file"
                  : category === "5"
                  ? ".xls or .xlsx file"
                  : category === "6"
                  ? ".pdf file"
                  : category === "7"
                  ? ".zip"
                  : currentpage === "latex_to_html"
                  ? " .tex"
                  : ".epub file"
              }`}</p>
            </div>
          </div>
        )}
      </div>
      {inputFiles && inputFiles.name?.length > 0 && (
        <div className="w-full max-h-fit mt-6 bg-white overflow-hidden rounded-[12px]">
          <div className="p-6 border-[1px] border-C4C6CC rounded-[12px]  bg-F8F9FA">
            <div className="bg-commonfill border-[1px] border-highlight py-4 flex flex-col justify-center w-full items-center rounded-[16px]">
              <div className="flex w-full px-4 items-center justify-between">
                <div className="flex items-center justify-between gap-4">
                  <span className="w-8 h-8">
                    <img
                      alt="epub_logo"
                      src={process.env.PUBLIC_URL + "/images/epub.svg"}
                      className="w-full h-full object-cover"
                    ></img>
                  </span>
                  <div className="flex flex-col items-start">
                    <p>{inputFiles !== undefined ? inputFiles.name : ""}</p>
                    <p className="text-8C8A9B">
                      {inputFiles.size
                        ? inputFiles.size >= 1000000
                          ? `${(inputFiles.size / 1024 / 1024).toFixed(2)} MB`
                          : inputFiles.size >= 1000
                          ? `${(inputFiles.size / 1024).toFixed(2)} KB`
                          : `${inputFiles.size} bytes`
                        : ""}
                    </p>
                  </div>
                </div>
                <div>
                  <button
                    onClick={() => {
                      setInputFiles([]);
                    }}
                  >
                    <img
                      src={process.env.PUBLIC_URL + "/images/cross.png"}
                      alt="close"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Fileupload;
